import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { api } from "../../services/api";
import Swal from "sweetalert2";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";

export default function ImportadorPromocao() {
    const [uploading, setUploading] = useState(false);
    const [workbook, setWorkbook] = useState(null);
    const [abas, setAbas] = useState([]);
    const [abaSelecionada, setAbaSelecionada] = useState("");
    const [dadosParaExibir, setDadosParaExibir] = useState([]);

    // FUNÇÃO AUXILIAR PARA LOADING COM DELAY (Garante que o modal apareça antes do processamento pesado)
    const mostrarLoading = (titulo, texto) => {
        return Swal.fire({
            title: titulo,
            text: texto,
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => { Swal.showLoading(); }
        });
    };

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        mostrarLoading('Lendo Arquivo', 'Aguarde o processamento inicial...');

        // Usamos setTimeout para dar tempo ao SweetAlert de renderizar antes do XLSX "travar" a CPU
        setTimeout(() => {
            const reader = new FileReader();
            reader.onload = (evt) => {
                try {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, { type: 'binary' });
                    setWorkbook(wb);
                    setAbas(wb.SheetNames);
                    setAbaSelecionada("");
                    setDadosParaExibir([]);
                    Swal.close();
                } catch (err) {
                    Swal.fire("Erro", "Falha ao ler planilha.", "error");
                }
            };
            reader.readAsBinaryString(file);
        }, 100);
    };

    const handleSelecaoAba = (e) => {
        const nomeAba = e.target.value;
        setAbaSelecionada(nomeAba);

        if (nomeAba) {
            mostrarLoading('Processando Guia', 'Limpando e formatando dados...');

            setTimeout(() => {
                const ws = workbook.Sheets[nomeAba];
                // 1. Pega os dados crus da planilha
                const rawData = XLSX.utils.sheet_to_json(ws, { defval: "" });

                // 2. Mapeia os dados limpando os espaços em branco (Trim) das chaves (nomes das colunas)
                const cleanData = rawData.map(row => {
                    const newRow = {};
                    Object.keys(row).forEach(key => {
                        // key.trim() remove o espaço de " PROM_PRECO " transformando em "PROM_PRECO"
                        newRow[key.trim()] = row[key];
                    });
                    return newRow;
                });

                setDadosParaExibir(cleanData);
                Swal.close();
            }, 100);
        } else {
            setDadosParaExibir([]);
        }
    };

    const processarEnvio = async () => {
        if (dadosParaExibir.length === 0) return;

        const { isConfirmed } = await Swal.fire({
            title: 'Confirmar Importação',
            text: `Deseja importar ${dadosParaExibir.length} registros?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, importar'
        });

        if (!isConfirmed) return;

        setUploading(true);

        Swal.fire({
            title: 'Sincronizando com Servidor',
            html: 'Progresso: <b>0%</b>',
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); }
        });

        const TAMANHO_LOTE = 500;
        const total = dadosParaExibir.length;

        try {
            for (let i = 0; i < total; i += TAMANHO_LOTE) {
                const lote = dadosParaExibir.slice(i, i + TAMANHO_LOTE);

                const progresso = Math.round((i / total) * 100);
                if (Swal.getHtmlContainer()) {
                    Swal.getHtmlContainer().querySelector('b').textContent = `${progresso}%`;
                }

                await api.post('/promocao/importar', lote);
            }

            Swal.fire("Sucesso", "Importação concluída!", "success");
            setDadosParaExibir([]);
            setAbas([]);
            setAbaSelecionada("");
        } catch (error) {
            Swal.fire("Erro", "Falha na comunicação com o servidor local.", "error");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="d-flex flex-column min-vh-100 bg-white">
            <Menu modulo="PROMO" />
            <main className="flex-grow-1 d-flex flex-column" style={{ marginTop: '60px' }}>
                <div className="border-bottom bg-light px-3 py-2">
                    <div className="row g-2 align-items-center">
                        <div className="col-auto">
                            <input type="file" id="fileInput" className="d-none" accept=".xlsx, .xls" onChange={handleFile} />
                            <button className="btn btn-sm btn-outline-secondary fw-bold" onClick={() => document.getElementById('fileInput').click()} disabled={uploading}>
                                <i className="fas fa-file-excel me-2"></i>Escolher Planilha
                            </button>
                        </div>
                        {abas.length > 0 && (
                            <div className="col-auto d-flex align-items-center">
                                <span className="small me-2 fw-bold text-danger">Guia:</span>
                                <select className="form-select form-select-sm border-danger" style={{ width: '200px' }} value={abaSelecionada} onChange={handleSelecaoAba} disabled={uploading}>
                                    <option value="">Selecione...</option>
                                    {abas.map(n => <option key={n} value={n}>{n}</option>)}
                                </select>
                            </div>
                        )}
                        {dadosParaExibir.length > 0 && (
                            <div className="col-auto ms-auto">
                                <button className="btn btn-sm btn-success fw-bold" onClick={processarEnvio} disabled={uploading}>
                                    <i className="fas fa-sync me-2"></i>Sincronizar {dadosParaExibir.length} itens
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <div className="flex-grow-1 overflow-hidden d-flex flex-column">
                    {dadosParaExibir.length > 0 ? (
                        <div className="table-responsive flex-grow-1">
                            <table className="table table-sm table-hover table-striped mb-0" style={{ fontSize: '0.75rem' }}>
                                <thead className="table-dark sticky-top">
                                    <tr>
                                        {Object.keys(dadosParaExibir[0]).map(key => (
                                            <th key={key} className="px-2 py-1 text-uppercase border-end border-secondary">{key}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {dadosParaExibir.map((item, idx) => (
                                        <tr key={idx}>
                                            {Object.values(item).map((val, i) => (
                                                <td key={i} className="px-2 py-1 text-nowrap border-end">{String(val)}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="m-auto text-center text-muted">
                            <i className="fas fa-upload fa-3x mb-3 opacity-25"></i>
                            <p>Carregue o arquivo para visualizar os dados</p>
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
}